export default "__VITE_ASSET__VxCu5B3U__"